import { Icon } from '@toggle/design-system';
import React from 'react';

import { usePostAlerts } from '~/react-query-hooks/events/use-event-alerts/useEventAlerts';

import styles from './AlertsIcon.module.scss';

export const AlertsIcon = () => {
  const { data } = usePostAlerts({ count_only: true });
  const unreadCount = data?.pages[0]?.unread_count ?? 0;

  return (
    <div className={styles.alertsIconRoot}>
      <Icon iconName="NotificationLine" size={24} />
      {unreadCount > 0 && (
        <span className={styles.unreadBadge}>
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </div>
  );
};
